import { H1 as _H1 } from "components/atoms/Heading";
import React from "react";
import { types, Text, Image, Repeater } from "react-bricks/frontend";
import styled from "styled-components";
import { backgroundColorProp } from "../utils/backgroundColor";
import TextBlock from "../common/TextBlock";
import { Link } from "@components/atoms";
import Button from "../common/Button";
import { LogoProps } from "../common/Logo";
import { color } from "styles/colours";
import { mobile } from "components/templates/Breakpoints";

export interface LandingPageFooterProps {
  logoImages?: types.RepeaterItems<LogoProps>;
  backgroundColor?: types.IColor;
}

const LandingPageFooter: types.Brick<LandingPageFooterProps> = ({
  logoImages = [],
  backgroundColor,
}) => {
  return (
    <Container background={backgroundColor?.color}>
      <LogoContainer>
        <Divider />
        <LogoWrapper>
          <Repeater
            propName="logoImages"
            items={logoImages}
            renderItemWrapper={(item, i) => (
              <>
                {i > 0 && <Line />}
                {item}
              </>
            )}
          />
        </LogoWrapper>
        <Divider />
      </LogoContainer>
      <TextContainer>
        <TextBlock propName={"text"} fontSize="1rem" lineHeight="1.5rem" />
      </TextContainer>
    </Container>
  );
};

LandingPageFooter.schema = {
  // Unique brick name
  name: "landing-page-footer",
  label: "Landing Page Footer",
  previewImageUrl: "/static/bricks/landing-page-footer.png",
  repeaterItems: [
    {
      name: "logoImages",
      itemType: "logo",
      itemLabel: "Logo",
      min: 1,
      max: 3,
    },
  ],
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    text: "2025 © Yu Life Ltd. Yu Life Ltd is authorised and regulated by the Financial Conduct Authority. Firm reference No. 783352. Yu Life Ltd is a company registered in England, company no. 10308260, registered office: 12 Mallow Street, London, EC1Y 8RQ.",
    logoImages: [
      {
        maxWidth: 170,
      },
    ],
    backgroundColor: { color: color.white },
  }),

  // Sidebar Edit controls for props
  sideEditProps: [backgroundColorProp],
};

export default LandingPageFooter;

const Container = styled.div<{ background?: string }>`
  width: 100%;
  background: ${(p) => p.background || color.white};
  padding: 5rem 10rem;

  ${mobile} {
    padding: 3rem 1rem;
  }
`;

const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  margin-bottom: 2rem;

  ${mobile} {
    gap: 0.75rem;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;

  ${mobile} {
    gap: 0.75rem;
  }
`;

const Line = styled.div`
  height: 5rem;
  border-left: 1px solid ${color.B240};
`;

const Divider = styled.div`
  width: 20rem;
  height: 1px;
  background: ${color.B240};

  ${mobile} {
    width: 4.5rem;
  }
`;

const TextContainer = styled.div`
  width: 100%;
  text-align: center;

  span {
    color: ${color.B2100};
  }
`;
